import React, { useEffect, useState } from "react";

export default function StockStatementView({ data, preview_url }) {
  if (!data) return null;

  const [editing, setEditing] = useState(false);
  const [totalAmount, setTotalAmount] = useState(
    data.total_amount || ""
  );
  const [loading, setLoading] = useState(false);

  // 🔹 Detect file type from preview_url
  const isExcel =
    preview_url &&
    (preview_url.endsWith(".xlsx") ||
      preview_url.endsWith(".xls") ||
      preview_url.includes(".xlsx") ||
      preview_url.includes(".xls"));

  const isPdf =
    preview_url &&
    (preview_url.endsWith(".pdf") || preview_url.includes(".pdf"));

  return (
    <>
      <br />

      {/* Header */}
      <div className="w-full text-left p-3 flex items-center gap-3 bg-[#5a6db3] ">
        <h2 className="text-lg font-semibold">
          Stock Statement Details
        </h2>
      </div>

      {/* Details */}
      <div className="border border-t-0 rounded-b-lg p-4 grid grid-cols-2 gap-6 bg-white shadow">
        <div>
          <h3 className="font-semibold mb-2">Client Information</h3>
          <p><b>Client Name:</b> {data.client_name || "N/A"}</p>
          <p><b>Document Name:</b> {data.document_name || "N/A"}</p>
          <p><b>Filename:</b> {data.filename || "N/A"}</p>
        </div>

        <div>
          <h3 className="font-semibold mb-2">Statement Information</h3>
          <p><b>Year End Date:</b> {data.year_end_date || "N/A"}</p>

          {!editing ? (
            <p>
              <b>Total Amount:</b>{" "}
              {data.currency} {totalAmount}
              <button
                onClick={() => setEditing(true)}
                className="ml-2 px-2 py-1 rounded text-sm"
                style={{ color: "#0000FF" }}
              >
                Edit
              </button>
            </p>
          ) : (
            <div className="flex items-center gap-2">
              <b>Total Amount:</b>
              <input
                type="number"
                value={totalAmount}
                onChange={(e) => setTotalAmount(e.target.value)}
                className="border rounded px-2 py-1"
              />

              {/* <button
                onClick={saveTotalAmount}
                disabled={loading}
                className="px-3 py-1 rounded text-sm"
                style={{ color: "#008000" }}
              >
                {loading ? "Saving..." : "Save"}
              </button> */}

              {/* <button
                onClick={() => setEditing(false)}
                className="px-3 py-1 rounded text-sm"
                style={{ color: "#FF0000" }}
              >
                Cancel
              </button> */}
            </div>
          )}

          <p>
            <b>Sub Total:</b>{" "}
            {data.currency} {data.sub_total || "0"}
          </p>
          <p>
            <b>Processing Status:</b>{" "}
            {data.processing_status || "N/A"}
          </p>
        </div>
      </div>

      {/* Extracted Notes */}
      <div
        className="mt-4 p-3 border rounded-lg text-black"
        style={{ background: "aliceblue" }}
      >
        <b>Extracted Content:</b>{" "}
        {data.extracted_content || "Not available"}
      </div>

      {/* 🔥 Excel Viewer */}
      {isExcel && preview_url && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">Excel Preview</h3>
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              preview_url
            )}`}
            width="100%"
            height="600"
            style={{ border: "1px solid #ccc", borderRadius: "8px" }}
            title="Excel Preview"
          />
        </div>
      )}

      {/* 📄 PDF Viewer */}
      {isPdf && preview_url && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">PDF Preview</h3>
          <iframe
            src={preview_url}
            width="100%"
            height="600"
            style={{ border: "1px solid #ccc", borderRadius: "8px" }}
            title="PDF Preview"
          />
        </div>
      )}

      {/* ❗ Fallback */}
      {!isExcel && !isPdf && preview_url && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">Document Preview</h3>
          <p className="text-gray-600">
            Preview not available for this file type.
          </p>
        </div>
      )}
    </>
  );
}
